import { injectable } from "inversify";

@injectable()
export class IntercomConfig {
    appId!: string;
}
